// ** Third Party Imports
import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Joins Tailwind class names the way shadcn-style components expect
 * (clsx for conditionals + tailwind-merge for conflict resolution).
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs))
